module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Don\u0027t repeat":"Не повторять","Always":"Всегда","Until date":"До даты","repeat_until":"Повторять до:"},"en":{"repeat_until":"Repeat until:"}}')
  delete Component.options._Ctor
}
